import { Backdrop, CircularProgress, } from "@mui/material";
// useStyles removed by Bearer Web Developer
export default function DisabledClickLoading() {

    return (
        <Backdrop sx={{
            position: 'fixed',
            zIndex: (theme) => theme.zIndex.modal + 1,
            color: '#fff',
        }} open={true} >
            <div className="container" onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                <CircularProgress color="primary" />
            </div>
        </Backdrop>

    )
}